export function loadRazorpayScript() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay"));
    document.body.appendChild(s);
  });
}

export async function payWithRazorpay({ order, keyId, prefill, description, onSuccess, onDismiss }) {
  await loadRazorpayScript();
  const rzp = new window.Razorpay({
    key: keyId,
    amount: order.amount,
    currency: order.currency,
    order_id: order.id,
    name: "IKSHA — Art + Architecture",
    description,
    prefill,
    theme: { color: "#E53827" },
    handler: onSuccess,
    modal: { ondismiss: onDismiss },
  });
  rzp.open();
}
